import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HERO, HERO_VIDEO, CTA_TEXT } from "../data";
import LeadForm from "./LeadForm";

const ease = [0.22, 1, 0.36, 1];
const rise = (d) => ({ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 1.1, ease, delay: d } });

export default function Hero() {
  const [reduce, setReduce] = useState(false);
  const [src, setSrc] = useState("");
  useEffect(() => {
    setReduce(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    setSrc(window.innerWidth < 768 ? HERO_VIDEO.sm : HERO_VIDEO.lg);
  }, []);

  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] flex grain overflow-hidden bg-[#172B38]">
      {reduce ? (
        <img src={HERO_VIDEO.poster} alt="" className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <video data-testid="hero-video" key={src} autoPlay muted playsInline preload="auto" poster={HERO_VIDEO.poster}
          className="absolute inset-0 w-full h-full object-cover" aria-hidden="true">
          {src && <source src={src} type="video/mp4" />}
        </video>
      )}
      <div className="absolute inset-0" aria-hidden="true"
        style={{ background: "linear-gradient(90deg, rgba(23,43,56,0.88) 0%, rgba(23,43,56,0.6) 38%, rgba(23,43,56,0.12) 70%, rgba(23,43,56,0.05) 100%), linear-gradient(180deg, rgba(23,43,56,0.55) 0%, rgba(23,43,56,0) 22%, rgba(23,43,56,0) 72%, rgba(23,43,56,0.55) 100%)" }} />

      <div className="wrap relative w-full grid lg:grid-cols-[minmax(0,1fr)_360px] xl:grid-cols-[minmax(0,1fr)_380px] gap-12 pt-32 md:pt-36 pb-10 md:pb-12 items-end">
        <div className="max-w-[720px] self-center lg:pb-10">
          <motion.h1 {...rise(0.1)} data-testid="hero-title" className="font-heading font-normal text-[#F4F1E9] text-[3.1rem] leading-[1.02] sm:text-7xl lg:text-[5.6rem] xl:text-[6.2rem]">
            {HERO.title[0]}<br />{HERO.title[1]}
          </motion.h1>
          <motion.p {...rise(0.3)} className="mt-7 text-[1.05rem] md:text-[1.3rem] leading-relaxed text-[#F4F1E9]/85 max-w-[34rem]">{HERO.sub}</motion.p>
          <motion.div {...rise(0.45)} className="mt-10 flex flex-wrap gap-4">
            <a href="#schedule" data-testid="hero-cta-primary" className="btn-light">{CTA_TEXT} <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></a>
            <Link to="/products" data-testid="hero-cta-secondary" className="btn-ghost-light">Explore Our Systems</Link>
          </motion.div>
          <motion.p {...rise(0.6)} className="mt-12 flex items-center gap-4 overline-hw text-[#F4F1E9]/80">
            <span className="w-14 h-px bg-[#F4F1E9]/60" /> {HERO.tagline}
          </motion.p>
        </div>

        <motion.div {...rise(0.55)} id="quote" data-testid="hero-form-card" className="bg-[#F4F1E9] p-6 scroll-mt-24">
          <p className="overline-hw text-[#344C59]">Free in-home water test</p>
          <h2 className="font-heading text-[1.7rem] leading-tight text-[#172B38] mt-1.5 mb-4">Know what's in your water.</h2>
          <LeadForm compact id="hero-form" source="Website Hero Form" />
        </motion.div>
      </div>
    </section>
  );
}
